// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { WizardSteps, IWizardSteps, WizardStepsResponse, IWizardStepsResponse, UpdateWizardStepRequest, IUpdateWizardStepRequest } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getCurrent(orgId?: string): ApiResult<WizardSteps> {
	return get<IWizardSteps>(`/api/wizard/${ orgId }`).then(result => result === undefined ? undefined :  new WizardSteps(result));
}

export async function getAll(): ApiResult<WizardSteps[]> {
	return get<IWizardSteps[]>(`/api/wizard`).then(result => result === undefined ? undefined : result.map(o => new WizardSteps(o)));
}

export async function getOrCreateWizard(orgId?: string): ApiResult<WizardStepsResponse> {
	return get<IWizardStepsResponse>(`/api/wizard/current-or-create/${ orgId }`).then(result => result === undefined ? undefined :  new WizardStepsResponse(result));
}

export async function save(wizardStep: WizardSteps): ApiResult<WizardSteps> {
	return post<IWizardSteps>(`/api/wizard`, wizardStep).then(result => result === undefined ? undefined :  new WizardSteps(result));
}

export async function updateStep(request: UpdateWizardStepRequest): ApiResult<WizardSteps> {
	return post<IWizardSteps>(`/api/wizard/update-step`, request).then(result => result === undefined ? undefined :  new WizardSteps(result));
}

export async function reset(orgId?: string): ApiResult<undefined> {
	return post(`/api/wizard/reset/${ orgId }`);
}

export async function deleteWizardStep(id?: string): ApiResult<undefined> {
	return del(`/api/wizard/${ id }`);
}
